export default "__VITE_ASSET__6e2d410b__"